import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { historyInstance } from 'src/utils/pageNavigator';

const RouterProvider = ({ children }) => {
  return <HistoryRouter history={historyInstance}>{children}</HistoryRouter>;
};

export default RouterProvider;
